export default "__VITE_ASSET__CcztBfqR__"